enum Methods {
  POST = "post",
  GET = "get",
  PUT = "put",
  DELETE = "delete",
}

const routesNotShowingLoader = [
  { routeName: "slpapp/Asset", method: Methods.POST },
  { routeName: "slpapp/Baseline/BaselineListByModuleId", method: Methods.POST },
  { routeName: "slpapp/Report/getFaultReport", method: Methods.POST },
  { routeName: "slpapp/Report/getBurnTimeReport", method: Methods.POST },
  { routeName: "slpapp/Report/getMotionTrafficReport", method: Methods.POST },
  { routeName: "slpapp/Report/getMotionHeatMapReport", method: Methods.POST },
  { routeName: "slpapp/Report/getEnergyReport", method: Methods.POST },
  { routeName: "slpapp/Report/getTestReport", method: Methods.POST },
  { routeName: "/slpapp/Report/getUserActivityReport", method: Methods.POST },
  { routeName: "slpapp/Report/getEnvironmentalReport", method: Methods.POST },
  { routeName: "/slpapp/Dashboard/BlockWithFailures", method: Methods.POST },
  { routeName: "/slpapp/GetCommand/SendGetCommandToDms", method: Methods.POST },
  { routeName: "/slpapp/TestConfiguration", method: Methods.POST },
  { routeName: "slpapp/GatewayGroup", method: Methods.PUT },
  { routeName: "slpapp/GatewayGroup", method: Methods.POST },
  { routeName: "slpapp/Asset/updatePredictiveLighting", method: Methods.PUT },
  { routeName: "/dmsapp/Device/getDevice/downloadExcel", method: Methods.POST },
  { routeName: "slpapp/Site/getSiteSummary", method: Methods.POST },
  { routeName: "slpapp/Site/downloadSiteSummaryCSV", method: Methods.POST },
  {
    routeName: "/slpapp/DriverModel/getDriverModel/downloadPdf",
    method: Methods.POST,
  },
  {
    routeName: "/slpapp/DriverModel/getDriverModel/downloadExcel",
    method: Methods.POST,
  },
  {
    routeName: "/slpapp/GatewayGroup/SaveToGatewayGroup",
    method: Methods.POST,
  },
  {
    routeName: "/slpapp/TestConfiguration/sendLightTestScheduleToDevice",
    method: Methods.POST,
  },
  {
    routeName: "/slpapp/SetCommand/getAssetGeneralConfigurationHistory",
    method: Methods.POST,
  },
  {
    routeName: "/slpapp/GetCommand/SendCommandToGetAssetConfiguration",
    method: Methods.POST,
  },
  {
    routeName: "/slpapp/GatewayZone/SaveCommandToGatewayByAssetCode",
    method: Methods.POST,
  },
  {
    routeName: "/slpapp/GatewayZone/GetZoneAckInfoByGateway",
    method: Methods.POST,
  },
];

export const isLoaderUnavailableRoute = (responseUrl: any, method: any) => {
  let matched = false;

  for (let routeObj of routesNotShowingLoader) {
    if (
      responseUrl.includes(routeObj?.routeName) &&
      method === routeObj.method
    ) {
      matched = true;
    }
  }
  return matched;
};
